import styled from "styled-components";

const ErrorMessage = styled.div`
  color: ${props => props.theme.textError};
  font-size: 12px;
  margin-bottom: 20px;
`;

export default ErrorMessage;
